import { z } from 'zod'

export const CreateProjectTemplateSchema = z.object({
  projectId: z.string({ required_error: 'Proje seçimi zorunludur.' }).uuid(),
  name: z
    .string({ required_error: 'Şablon adı zorunludur.' })
    .min(3, 'Şablon adı en az 3 karakter olmalıdır.')
    .max(200),
  description: z.string().max(1000).nullable().optional(),
})

export const ApplyProjectTemplateSchema = z.object({
  projectId: z.string({ required_error: 'Proje seçimi zorunludur.' }).uuid(),
  startDate: z.string({ required_error: 'Başlangıç tarihi zorunludur.' }).date(),
})

export type CreateProjectTemplateInput = z.infer<typeof CreateProjectTemplateSchema>
export type ApplyProjectTemplateInput = z.infer<typeof ApplyProjectTemplateSchema>

/** Snapshot içindeki aşama yapısı */
export interface TemplatePhase {
  title: string
  sortOrder: number
  startDate: string | null
  endDate: string | null
  isDraft: boolean
  milestoneTitle: string | null
  items: Array<{
    title: string
    description: string | null
    sortOrder: number
    startDate: string | null
    dueDate: string | null
  }>
}

/** Snapshot içindeki kilometre taşı yapısı */
export interface TemplateMilestone {
  title: string
  description: string | null
  sortOrder: number
  startDate: string | null
  dueDate: string
}

/** Template snapshot JSON yapısı */
export interface TemplateSnapshot {
  phases: TemplatePhase[]
  milestones: TemplateMilestone[]
}
